import JimiCuentasPanel from "@/components/configuracion/JimiCuentasPanel";
import Toggle from "@/ui/Toggle";
import SeccionLayout, { BloqueSeccion, PieGuardar } from "../SeccionLayout";
import { AYUDA_SECCION } from "@/components/ayuda/vistas/configuracion";
import { useAppSettings, useBorradorSeccion } from "../useAppSettings";

/**
 * Revisión automática de los tickets del portal de Jimi + las cuentas que son
 * nuestras en ese portal.
 *
 * Van juntas porque la lista de cuentas sólo tiene sentido con la revisión
 * encendida: es lo que le permite distinguir una respuesta del técnico de un
 * mensaje que escribió nuestro propio equipo.
 */
export default function IntegracionJimi() {
  const { settings, cargando, guardando, guardar, alternar } = useAppSettings();
  const { valores, set, sucio } = useBorradorSeccion(settings, (s) => ({
    jimi_revision_hora: s.jimi_revision_hora,
  }));

  if (cargando || !settings || !valores) {
    return <p className="text-sm text-zinc-500">Cargando…</p>;
  }

  return (
    <SeccionLayout
      ayuda={AYUDA_SECCION["jimi"]}
      ancho="formulario"
      titulo="Tickets de Jimi"
      descripcion="Cada mañana el sistema entra solo al portal de Jimi y trae lo que el técnico haya contestado en los tickets abiertos: lo deja en la bitácora del caso —traducido si viene en chino— y le avisa a quien lo tenga asignado. Va de a un ticket por minuto y en desorden, para no saturar a Jimi. También puedes revisar un caso cuando quieras desde su botón."
    >
      <div className="card space-y-4">
        <BloqueSeccion titulo="Revisión automática">
          <Toggle
            checked={settings.jimi_revision_activa}
            onChange={(v) =>
              void alternar(
                "jimi_revision_activa",
                v,
                v ? "Revisión de Jimi encendida" : "Revisión de Jimi apagada",
              )
            }
            label="Revisar los tickets de Jimi cada mañana"
            hint="Apagarlo detiene solo la revisión automática: el botón del caso sigue funcionando."
          />
          <label className="block text-xs text-zinc-400">
            Hora de arranque
            <input
              type="time"
              value={valores.jimi_revision_hora}
              onChange={(e) => set({ jimi_revision_hora: e.target.value })}
              disabled={!settings.jimi_revision_activa}
              className="input ml-2 w-32 disabled:opacity-50"
            />
            <span className="mt-1 block text-[11px] text-zinc-500">
              Hora de Monterrey. A esa hora en China ya es de noche, así que las respuestas del día
              ya están puestas.
            </span>
          </label>
          <PieGuardar
            sucio={sucio}
            guardando={guardando}
            onGuardar={() => void guardar(valores, "Hora de arranque guardada")}
            textoGuardar="Guardar la hora"
          />
        </BloqueSeccion>

        <JimiCuentasPanel />
      </div>
    </SeccionLayout>
  );
}
